import React from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../../../context/useAppContext';

import { Message, DateTimeInput } from '@weezevent/nacre';

const DateRangeCondition = ({ condition, handleCondition }) => {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();
    const locale = i18next.language;
    const currentYear = new Date().getFullYear();

    return (
        <>
            <Message type="default" title={t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.date-range.title')}>
                {t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.date-range.message')}
            </Message>

            <DateTimeInput
                locale={locale}
                value={condition.start_date}
                timezone={organization.timezone}
                dateProps={{ minYear: currentYear }}
                timeLabel={t('ticket.event.start_hour')}
                dateLabel={t('ticket.event.start_date')}
                onChange={date => handleCondition('start_date', date)}
            />
            <DateTimeInput
                locale={locale}
                value={condition.end_date}
                timezone={organization.timezone}
                dateProps={{ minYear: currentYear }}
                timeLabel={t('ticket.event.end_hour')}
                dateLabel={t('ticket.event.end_date')}
                onChange={date => handleCondition('end_date', date)}
            />
        </>
    );
};

export default DateRangeCondition;
